export default __webpack_public_path__ + "static/media/notifications.4480abee.svg";